import { siteInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">💡 ABOUT US</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2 mb-6">关于漫漫漫画</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {siteInfo.intro}
          </p>
          <div className="flex items-center justify-center gap-8 md:gap-12">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">{siteInfo.stats.total}</div>
              <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
            </div>
            <div className="w-px h-10 bg-background-300"></div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading">{siteInfo.stats.daily}</div>
              <div className="text-xs text-foreground-500 mt-1">每日更新</div>
            </div>
            <div className="w-px h-10 bg-background-300"></div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-secondary-500 font-heading">{siteInfo.stats.users}</div>
              <div className="text-xs text-foreground-500 mt-1">漫友聚集</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}